import * as colorPalette from '../palette';

export const pageBackground = colorPalette.navy100;
export const pageBackgroundModalActive = colorPalette.navy200;
export const pageBackgroundTopLeft = colorPalette.navy100;
export const pageBackgroundBottomRight = colorPalette.blue150;
export const pageBackgroundLineTop = colorPalette.white;
export const pageBackgroundLineMid = colorPalette.navy100;
export const pageBackgroundLineBottom = colorPalette.blue150;
export const pageText = '#272630';
export const pageTextSubdued = colorPalette.navy300;
export const pageTextPositive = colorPalette.purple500;
export const pageTextLink = colorPalette.blue600;
export const modalBackground = colorPalette.white;
export const modalBorder = colorPalette.white;
export const cardBackground = colorPalette.white;
export const cardBorder = colorPalette.purple500;
export const cardShadow = colorPalette.navy700;
export const tableBackground = colorPalette.white;
export const tableRowBackgroundHover = colorPalette.blue100;
export const tableText = colorPalette.navy700;
export const tableTextSelected = colorPalette.navy700;
export const tableTextHover = colorPalette.navy900;
export const tableTextEditing = colorPalette.navy50;
export const tableTextEditingBackground = colorPalette.purple500;
export const tableTextInactive = colorPalette.navy300;
export const tableHeaderText = colorPalette.navy500;
export const tableHeaderBackground = colorPalette.navy50;
export const tableBorder = colorPalette.navy150;
export const tableBorderSelected = colorPalette.purple500;
export const tableBorderHover = colorPalette.purple400;
export const tableBorderSeparator = colorPalette.navy400;
export const tableRowBackgroundHighlight = colorPalette.purple100;
export const tableRowBackgroundHighlightText = colorPalette.navy700;
export const tableRowHeaderBackground = colorPalette.navy50;
export const tableRowHeaderText = colorPalette.navy800;
export const sidebarBackground = colorPalette.blue800;
export const sidebarItemBackground = colorPalette.blue800;
export const sidebarItemBackgroundSelected = colorPalette.blue800;
export const sidebarItemBackgroundHover = colorPalette.blue700;
export const sidebarItemAccent = colorPalette.blue800;
export const sidebarItemAccentSelected = colorPalette.purple300;
export const sidebarItemAccentHover = colorPalette.blue700;
export const sidebarItemText = colorPalette.navy100;
export const sidebarItemTextSelected = colorPalette.purple300;
export const sidebarItemTextHover = colorPalette.navy50;
export const tooltipBackground = colorPalette.navy50;
export const tooltipBorder = colorPalette.navy50;
export const menuBackground = colorPalette.navy50;
export const menuItemBackground = colorPalette.navy50;
export const menuItemBackgroundHover = colorPalette.navy150;
export const menuItemText = colorPalette.navy800;
export const menuItemTextHover = colorPalette.navy800;
export const menuItemTextSelected = colorPalette.navy800;
export const menuItemTextHeader = colorPalette.purple600;
export const menuBorder = colorPalette.navy100;
export const menuBorderHover = colorPalette.purple100;
export const altMenuBackground = colorPalette.blue800;
export const altMenuItemBackground = colorPalette.blue800;
export const altMenuItemBackgroundHover = colorPalette.blue700;
export const altMenuItemText = colorPalette.navy100;
export const altMenuItemTextHover = colorPalette.navy50;
export const altMenuItemTextSelected = colorPalette.purple300;
export const altMenuItemTextHeader = colorPalette.purple300;
export const altMenuBorder = colorPalette.blue700;
export const altMenuBorderHover = colorPalette.purple300;
export const mobileNavBackground = colorPalette.white;
export const mobileNavItem = 'rgb(142, 142, 143)';
export const mobileNavItemSelected = colorPalette.purple500;

// Button
export const buttonMenuText = colorPalette.navy100;
export const buttonMenuTextHover = colorPalette.navy50;
export const buttonMenuBackground = 'transparent';
export const buttonMenuBackgroundHover = 'rgba(200, 200, 200, .25)';
export const buttonMenuBorder = colorPalette.navy500;

export const buttonMenuSelectedText = colorPalette.green800;
export const buttonMenuSelectedTextHover = colorPalette.orange800;
export const buttonMenuSelectedBackground = colorPalette.orange200;
export const buttonMenuSelectedBackgroundHover = colorPalette.orange300;
export const buttonMenuSelectedBorder = buttonMenuSelectedBackground;

export const buttonPrimaryText = colorPalette.white;
export const buttonPrimaryTextHover = buttonPrimaryText;
export const buttonPrimaryBackground = colorPalette.purple500;
export const buttonPrimaryBackgroundHover = buttonPrimaryBackground;
export const buttonPrimaryBorder = buttonPrimaryBackground;
export const buttonPrimaryShadow = 'rgba(0, 0, 0, 0.3)';

export const buttonPrimaryDisabledText = colorPalette.white;
export const buttonPrimaryDisabledBackground = colorPalette.navy300;
export const buttonPrimaryDisabledBorder = buttonPrimaryDisabledBackground;

export const buttonNormalText = colorPalette.navy900;
export const buttonNormalTextHover = buttonNormalText;
export const buttonNormalBackground = colorPalette.white;
export const buttonNormalBackgroundHover = buttonNormalBackground;
export const buttonNormalBorder = colorPalette.navy150;
export const buttonNormalShadow = 'rgba(0, 0, 0, 0.2)';

export const buttonNormalDisabledText = colorPalette.navy400;
export const buttonNormalDisabledBackground = buttonNormalBackground;
export const buttonNormalDisabledBorder = buttonNormalBorder;

export const buttonBareText = buttonNormalText;
export const buttonBareTextHover = buttonNormalText;
export const buttonBareBackground = 'transparent';
export const buttonBareBackgroundHover = 'rgba(100, 100, 100, .15)';
export const buttonBareBackgroundActive = 'rgba(100, 100, 100, .25)';
export const buttonBareDisabledText = buttonNormalDisabledText;
export const buttonBareDisabledBackground = buttonBareBackground;

export const noticeBackground = colorPalette.green50;
export const noticeText = colorPalette.green500;
export const noticeAccent = colorPalette.green200;
export const warningBackground = colorPalette.orange200;
export const warningText = colorPalette.orange800;
export const warningAccent = colorPalette.orange400;
export const errorBackground = colorPalette.red50;
export const errorText = colorPalette.red500;
export const errorAccent = colorPalette.red200;
export const formLabelText = colorPalette.blue500;
export const formInputBackground = colorPalette.navy50;
export const formInputBackgroundSelected = colorPalette.white;
export const formInputBackgroundSelection = colorPalette.purple500;
export const formInputBorder = colorPalette.navy300;
export const formInputTextReadOnlySelection = colorPalette.navy50;
export const formInputBorderSelected = colorPalette.purple500;
export const formInputText = colorPalette.navy700;
export const formInputTextSelected = colorPalette.navy50;
export const formInputTextPlaceholder = colorPalette.navy300;
export const formInputTextPlaceholderSelected = colorPalette.navy200;
export const formInputTextSelection = colorPalette.navy100;
export const formInputShadowSelected = colorPalette.purple300;
export const formInputTextHighlight = colorPalette.purple500;
export const pillBackground = colorPalette.navy150;
export const pillText = colorPalette.navy800;
export const pillBorder = colorPalette.navy150;
export const pillBackgroundSelected = colorPalette.purple150;
export const pillTextSelected = colorPalette.navy700;
export const pillBorderSelected = colorPalette.purple500;
